import { isAcorisAlsaceLocalRegime } from "./pricerRegime";

// For régime local (Alsace-Moselle / MSA-RL) only the attestation is accepted
// and the carte vitale is refused; for every other régime the carte vitale is
// accepted as a fallback. Returns the hint copy matching the given régime.
export const getAttestationHint = (socialRegime, { general, local } = {}) =>
  isAcorisAlsaceLocalRegime(socialRegime) ? local : general;
